// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.selected-schools-container {
  margin: 0 auto;
  max-width: 1800px;
  padding: 20px 9px;
  width: 90%;
  min-width: 50%;
}
.selected-schools-container .schools-container {
  border-radius: 10px;
  background: #D1D3D4;
  border: none;
  display: flex;
  flex-direction: row;
  min-height: 300px;
  justify-content: flex-start;
  padding: 10px;
  min-width: 25%;
}

.selected-schools-container-static {
  margin: 0 auto;
  max-width: 1800px;
  padding: 10px;
  width: 90%;
}
.selected-schools-container-static .selected-schools-block {
  border-radius: 10px;
  background: #D1D3D4;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 300px;
  justify-content: center;
  padding: 10px;
  margin-bottom: 20px;
  margin: 10px auto;
}
.selected-schools-container-static .selected-schools-blocks-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
.selected-schools-container-static .selected-schools-blocks-container .selected-schools-blocks {
  border-radius: 10px;
  background: #D1D3D4;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 10px;
  padding: 10px;
}
.selected-schools-container-static .selected-schools-blocks-container .selected-schools-blocks .block-school {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.selected-schools-container-static .selected-schools-blocks-container .selected-schools-blocks .block-text {
  height: 100px;
  line-height: 1rem;
  margin-bottom: 10px;
}
.selected-schools-container-static .selected-schools-blocks-container .selected-schools-blocks .block-text h6 {
  font-size: 0.9rem;
}
.selected-schools-container-static .selected-schools-blocks-container .selected-schools-blocks .block-text span {
  font-size: 0.8rem;
}

.reasons-tab-card-container {
  height: 525px;
  padding: 0 20px;
  position: relative;
  min-width: 228px;
  width: 24.7%;
}

.card-active {
  border-radius: 10px 10px 0 0;
  background: #D1D3D4;
  border-color: #0669B3 #0669B3 #D1D3D4 #0669B3;
  border-style: solid;
  border-width: 2px;
  bottom: -2px;
  z-index: 999;
}

.selected-schools-tab-container {
  display: flex;
  margin-left: 16px;
  position: relative;
}
.selected-schools-tab-container .selected-schools-tab {
  border-radius: 10px 10px 0 0;
  background-color: white;
  border-color: #808080 #808080 #0669B3 #808080;
  border-style: solid;
  border-width: 1px 1px 2px 1px;
  bottom: -12px;
  color: #636161;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  height: 50px;
  margin-right: 10px;
  min-width: 25%;
  padding: 10px 10px 5px 15px;
  position: relative;
}
.selected-schools-tab-container .selected-schools-tab .selected-count {
  display: flex;
  flex-direction: row;
  font-size: 0.6rem;
  margin-top: 5px;
}
.selected-schools-tab-container .selected-schools-tab .selected-count .tab-circle {
  border-radius: 50px;
  background-color: #636161;
  color: white;
  font-size: 0.84rem;
  height: 20px;
  width: 20px;
  white-space: nowrap;
}
.selected-schools-tab-container .selected-schools-tab .selected-count .active-circle {
  background-color: #0669B3;
  color: white;
}
.selected-schools-tab-container .selected-schools-tab .selected-count span {
  margin-left: 3px;
  margin-top: 2px;
}
.selected-schools-tab-container .active-selected-school {
  background-color: #D1D3D4;
  border-color: #0669B3 #0669B3 #D1D3D4 #0669B3;
  border-width: 2px;
  bottom: -2px;
  color: #19608f;
  height: 60px;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SelectedSchools.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AAUJ;AATI;ECNA,mBDO0B;EACtB,mBDQA;ECPA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;AAWR;;AARA;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;AAWJ;AAVI;ECvBA,mBDwB0B;EACtB,mBDTA;ECUA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAYR;AAVI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAYR;AAXQ;ECxCJ,mBDyC8B;EACtB,mBD1BJ;EC2BI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;AAaZ;AAZY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAchB;AAZY;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;AAchB;AAbgB;EACI,iBAAA;AAepB;AAbgB;EACI,iBAAA;AAepB;;AATA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAYJ;;AAVA;EC3EI,4BD4EsB;EACtB,mBD7DI;EC8DJ,6CAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAaJ;;AAVA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;AAaJ;AAXI;EC1FA,4BD2F0B;EACtB,uBAAA;EACA,6CAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,cD7EA;EC8EA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;AAaR;AAZQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAcZ;AAbY;EChHR,mBDiHkC;EACtB,yBD9FR;EC+FQ,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAehB;AAbY;EACI,yBDpGH;ECqGG,YAAA;AAehB;AAbY;EACI,gBAAA;EACA,eAAA;AAehB;AAXI;EACI,yBDpHA;ECqHA,6CAAA;EACA,iBAAA;EACA,YAAA;EACA,cDnIE;ECoIF,YAAA;EACA,YAAA;AAaR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.selected-schools-container {\n    margin: 0 auto;\n    max-width: 1800px;\n    padding: 20px 9px;\n    width: 90%;\n    min-width: 50%;\n    .schools-container {\n        @include borderRadius(10px);\n        background: $grey1;\n        border: none;\n        display: flex;\n        flex-direction: row;\n        min-height: 300px;\n        justify-content: flex-start;\n        padding: 10px;\n        min-width: 25%;\n    }\n}\n.selected-schools-container-static {\n    margin: 0 auto;\n    max-width: 1800px;\n    padding: 10px;\n    width: 90%;\n    .selected-schools-block {\n        @include borderRadius(10px);\n        background: $grey1;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        min-height: 300px;\n        justify-content: center;\n        padding: 10px;\n        margin-bottom: 20px;\n        margin: 10px auto;\n    }\n    .selected-schools-blocks-container {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        width: 100%;\n        .selected-schools-blocks {\n            @include borderRadius(10px);\n            background: $grey1;\n            display: flex;\n            flex-direction: column;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            margin: 0 10px;\n            padding: 10px;\n            .block-school {\n                display: flex;\n                flex-direction: row;\n                justify-content: center;\n            }\n            .block-text {\n                height: 100px;\n                line-height: 1rem;\n                margin-bottom: 10px;;\n                h6 {\n                    font-size: 0.9rem;\n                }\n                span {\n                    font-size: 0.8rem;\n                }\n            }\n        }\n    }\n}\n.reasons-tab-card-container {\n    height: 525px;\n    padding: 0 20px;\n    position: relative;\n    min-width: 228px;\n    width: 24.7%;\n}\n.card-active {\n    @include borderRadius(10px 10px 0 0);\n    background: $grey1;\n    border-color: $pearl-blue $pearl-blue $grey1 $pearl-blue;\n    border-style: solid;\n    border-width: 2px;\n    bottom: -2px;\n    z-index: 999;\n}\n\n.selected-schools-tab-container {\n    display: flex;\n    margin-left: 16px;\n    position: relative;\n\n    .selected-schools-tab {\n        @include borderRadius(10px 10px 0 0);\n        background-color: white;\n        border-color: $grey3 $grey3 $pearl-blue $grey3;\n        border-style: solid;\n        border-width: 1px 1px 2px 1px;\n        bottom: -12px;\n        color: $grey4;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        font-weight: 600;\n        height: 50px;\n        margin-right: 10px;\n        min-width: 25%;\n        padding: 10px 10px 5px 15px;\n        position: relative;\n        .selected-count {\n            display: flex;\n            flex-direction: row;\n            font-size: 0.6rem;\n            margin-top: 5px;\n            .tab-circle {\n                @include borderRadius(50px);\n                background-color: $grey4;\n                color: white;\n                font-size: 0.84rem;\n                height: 20px;\n                width: 20px;\n                white-space: nowrap;\n            }\n            .active-circle {\n                background-color: $pearl-blue;\n                color: white;\n            }\n            span {\n                margin-left: 3px;\n                margin-top: 2px;\n            }\n        }\n    }\n    .active-selected-school {\n        background-color: $grey1;\n        border-color: $pearl-blue $pearl-blue $grey1 $pearl-blue;\n        border-width: 2px;\n        bottom: -2px;\n        color: $dk-blue;\n        height: 60px;\n        z-index: 999;\n    }\n}\n\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
